import { deleteDoc, doc } from 'firebase/firestore';
import { FcmTokenSchema } from '@kilat/shared';

import { db } from '../firebase.js';
import { createRepo } from './_base.js';

/**
 * users/{uid}/fcmTokens/{tokenId} — one row per device with agent push on.
 * Doc id is the sanitised token so re-registering collapses to one row. The
 * server prunes rows FCM reports dead; sign-out deletes this device's.
 *
 * `delete` is added here because this app's repo base has none, and a token
 * row is genuinely disposable (nothing references it by id).
 */
export function fcmTokensRepoFor(uid: string) {
  const path = `users/${uid}/fcmTokens`;
  const base = createRepo({ path, schema: FcmTokenSchema, name: path });
  return {
    get: base.get,
    set: base.set,
    delete: (id: string): Promise<void> => deleteDoc(doc(db, path, id)),
  };
}
